import React from "react";
import { Grid, GridItem } from "@sainsburys-tech/fable";
import PropTypes from "prop-types";
import { ToggleButtonGroup, ToggleButton, Checkbox } from "@sainsburys-tech/fable";
import * as status from "../../model/alerts/alertStatusKeys";

const AlertWorkflow = props => (
  <React.Fragment>
    <h4 style={{marginBottom: '20px'}}>Workflow</h4>
    <Grid cols={2}>
      <GridItem
        className="cb-c-alert-workflow"
        colSpan={{ xs: 2, sm: 2, lg: 1 }}
      >
      <ToggleButtonGroup
        alpha
        value={props.alertStatus.code}
        onChange={props.onStatusChanged}
        style={{ marginBottom: "20px" }}
      >
        <ToggleButton key={status.OPEN} value={status.OPEN}>
          {status.OPEN}
        </ToggleButton>
        <ToggleButton key={status.INVESTIGATING} value={status.INVESTIGATING}>
          {status.INVESTIGATING}
        </ToggleButton>
        <ToggleButton key={status.CLOSED} value={status.CLOSED}>
          {status.CLOSED}
        </ToggleButton>
      </ToggleButtonGroup>
      <Checkbox
        name="IncludeDataInBaseline"
        label="Include alert data in the baseline calculations"
        checked={props.includeDataInBaseline === true}
        onChange={props.onIncludeDataInBaselineChanged}
      />
      </GridItem>
    </Grid>
  </React.Fragment>
);

AlertWorkflow.propTypes = {
  onStatusChanged: PropTypes.func.isRequired,
  includeDataInBaseline: PropTypes.bool.isRequired
};

export default AlertWorkflow;
